import uuid from 'uuid-random';

import { LoginExtendedErrorPopup } from './components/LoginExtendedErrorPopup';

import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

const popupId = uuid();

export const showLoginExtendedErrorPopup = ({
    onClose,
    articleId,
    messageToParse,
    title,
    onlyArticle,
    withLogo,
    expirationDate
} = {}) =>
    addPopupAction({
        id: popupId,
        component: LoginExtendedErrorPopup,
        layer: LAYER.LOGIN,
        onClose,
        articleId,
        messageToParse,
        expirationDate,
        title,
        onlyArticle,
        withLogo
    });
